import {useIntl} from 'react-intl';
import {MdCheckCircle as SuccessIcon} from '@react-icons/all-files/md/MdCheckCircle';
import {AppButton} from '@components/Core/buttons/AppButton/AppButton';
import './HardwareTokenSuccess.less';

interface HardwareTokenSuccessProps {
    onClose: () => void;
}

/**
 * Success display component shown after successful hardware token signing.
 */
export function HardwareTokenSuccess({
    onClose
}: HardwareTokenSuccessProps): JSX.Element {
    const {formatMessage} = useIntl();

    return (
        <div
            className="hardware-token-success"
            data-wdio="test-hardware-token-success"
        >
            <div className="hardware-token-success-content">
                <SuccessIcon
                    className="hardware-token-success-icon"
                    aria-hidden
                />
                <p className="hardware-token-success-message">
                    {formatMessage({id: 'hardwareToken.success', defaultMessage: 'Document signed successfully'})}
                </p>
            </div>
            <div className="hardware-token-success-actions">
                <AppButton
                    onClick={onClose}
                    data-wdio="test-hardware-token-success-close"
                >
                    {formatMessage({id: 'hardwareToken.button.continue', defaultMessage: 'Continue'})}
                </AppButton>
            </div>
        </div>
    );
}
